const productFilterNames = {
  rating: 'rating',
  brands: 'brands',
  types: 'types',
  notes: 'notes',
  tags: 'tags',
}


export default productFilterNames
